import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/auth/page.tsx");
